import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AddEditWorkgroupComponent } from 'src/app/components/settings/add-edit-workgroup/add-edit-workgroup.component';
import { WorkgroupList } from 'src/app/models/workgroup-information.model';
import { DeleteWorkgroupModal, deleteWorkgroupModalOptions } from '../../delete-workgroup/delete-workgroup.modal';

@Component({
  selector: 'app-workgroupListItem',
  templateUrl: './workgrouplistitem.component.html'
})
export class WorkgroupListItemComponent implements OnInit {

  @Input('organisation') organisation!: any;
  @Input('organisationWorkgroup') organisationWorkgroup!: any;
  @Input('workgroupList') workgroupList!: WorkgroupList[];
  @Output('requestRefreshWorkgroups') requestRefreshWorkgroupsEmitter = new EventEmitter();

  constructor(private modalService: NgbModal) {
    // Must not be empty. It's approved by a comment.
  }

  ngOnInit(): void {
    // Must not be empty. It's approved by a comment.
  }

  deleteWorkgroup() {
    const modalRef = this.modalService.open(DeleteWorkgroupModal, deleteWorkgroupModalOptions);
    modalRef.componentInstance.workgroupGuid = this.organisationWorkgroup.guid;
    modalRef.componentInstance.workgroupName = this.organisationWorkgroup.name;
    modalRef.componentInstance.organisationGuid = this.organisation.guid;
    modalRef.closed.subscribe({
      next: (deleteSuccesfull) => {
        if (deleteSuccesfull !== true) {
          return;
        }
        // on succesfull delete bubble/emit the refresh up
        this.requestRefreshWorkgroupsEmitter.emit();
      }
    });
  }

  dialogWorkgroup(action: string) {
    let ngbModalOptions: NgbModalOptions = {
      keyboard: false,
      centered: true,
      size: 'lg',
      windowClass: 'dialog-bg-white'
    };
    const modalRef = this.modalService.open(AddEditWorkgroupComponent, ngbModalOptions);
    modalRef.componentInstance.action = action;
    modalRef.componentInstance.workgroupList = this.workgroupList;
    modalRef.componentInstance.organisationGuid = this.organisation.guid;
    modalRef.componentInstance.workgroupGuid = this.organisationWorkgroup.guid;
    modalRef.componentInstance.workgroupName = this.organisationWorkgroup.name;
    modalRef.componentInstance.workgroupMembers = this.organisationWorkgroup.workgroupMembers;
    modalRef.closed.subscribe({
      next: () => {
        this.requestRefreshWorkgroupsEmitter.emit();
      }
    });
  }
}
